module.exports = __webpack_public_path__ + "media/images/app/how-it-works/mid-0a1cdae20fe242bf5206a383570abd50.webp";